type ProcessingStatusFetching = {
    name: "FETCHING";
    progress: number;
};

type ProcessingStatusWehoo = ProcessingStatusFetching;
type ProcessingStatus = string;
type Processing = { [id: string]: ProcessingStatus };

const setProcessingStatus = (
    processing: Processing,
    id: string,
    status: ProcessingStatus,
): Processing => {
    const p = { ...processing };
    p[id] = status;
    return p;
};

const removeProcessingStatus = (
    processing: Processing,
    id: string,
): Processing => {
    const p = { ...processing };
    delete p[id];
    return p;
};

export { removeProcessingStatus, setProcessingStatus };
export type { Processing, ProcessingStatus, ProcessingStatusWehoo };
